<template>
  <div class="fluid w-100 accordion_panel">
    <div class="courses_section accordion" v-if="isCoursesLoaded">
      <template v-if="programCourses.length > 0">
        <div class="list_container">
          <template v-for="(pg, i) in programCourses">
            <div>
              <div class="accordion_crd">
                <b-card-header header-tag="header" class="row sec_hd head head_1" role="tab" block v-b-toggle="'req_1'" variant="info">
                  <div class="col-1 ic_container">
                    <div class="ic ic-remove_circle"></div>
                    <div class="ic ic-add_circle"></div>
                  </div>
                  <div class="col-10 hd_txt">
                    <div>{{pg.title}} </div>
                  </div>
                </b-card-header>

                <b-collapse id="req_1" visible role="tabpanel" v-if="pg.courseRequirement" >
                  <b-card-body class="accordion_crd_content">

                    <div class="row sec_content">
                      <div class="col-12 sec_txt">
                        <div>{{pg.courseRequirement}}</div>
                      </div>
                    </div>

                  </b-card-body>
                </b-collapse>
              </div>

              <div class="row sec_content">
                <div class="col-12 sub_sec_txt">
                  <div class="entity_node_tree">
                    <tree-node v-for="category in pg.children" :key="category.title" :category="category" :tabIndex="1"> </tree-node>
                  </div>
                </div>
              </div>

            </div>
          </template>
        </div>
      </template>
    </div>

  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import TreeNode from './TreeNode'

  export default {
    name: 'program-courses',
    props: ['pathwayId'],
    components: {
      TreeNode
    },
    data () {
      return {
        programCourses: [],
        isCoursesLoaded: false
      }
    },
    mounted () {
      this.loadProgramCourseList(this.pathwayId).then(result => {
        this.programCourses = result
        this.isCoursesLoaded = true
      })
    },
    methods: {
      ...mapActions([
        'loadProgramCourseList'
      ])
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramCourses.vue